<template>
    <div class="question-wrapper">
		<detail-title
			:title="isAnswer ? '问答专区' : '文章专区'"
			:isShowTitle="isShowTitle"
			:detailInfo="detailInfo"
            :isPreview="true"
            :isAnswer="isAnswer"
			@toPersonal="toPersonal">
		</detail-title>
		<section class="content-wrapper">
			<div class="center-content">
				<div class="center-top-content">
					<div class="basic-info">
						<div class="questioner-info" v-if="detailInfo.created_by">
							<span class="user-portrait" @click="toPersonal">
								<img
									class="identity-icon"
									width="26"
									height="26"
									src="../../images/personal_center/avatar_default.png"
									v-if="detailInfo.created_by.avatar.substr(0, 1) == '?'"/>
								<img :src="detailInfo.created_by.avatar" alt="" width="26" height="26" v-else />
							</span>
							<span class="questioner-name">{{detailInfo.created_by.nick_name}}</span>
							<span class="question-time">于{{ detailInfo.updated_on }}</span>
							<span>发布</span>
						</div>
						<ul class="tags">
							<li
								v-for="(item, index) in detailInfo.tags"
								:key="index">
								{{ item.title }}
							</li>
						</ul>
					</div>
					<div
						class="question-content markdown-body"
						v-if="detailInfo.description !== '<p><br></p>' && detailInfo.description !== ''">
						<p
							class="question-desc img-hook"
							v-html="filterXSS(afterhtmlData)"
							ref="descHook"
							@click.stop="getImgUrl($event)">
						</p>
					</div>
				</div>
			</div>

			<div class="right-content">
				<communityRightContent
                    v-if="detailInfo.tags"
					ref="rightChild"
					:tags="detailInfo.tags"
					:isAnswer="isAnswer">
				</communityRightContent>
			</div>
			<goback></goback>
		</section>
    </div>
</template>
<script type="text/javascript">
	import mavonEditor from 'mavon-editor'
	import loading from '../loading.vue'
	import goback from '../common/goback.vue'
	import communityRightContent from '../common/communityRightContent.vue'
	import detailTitle from './detailTitle.vue'
	import tools from '@/js/tools.js'
	export default {
		components: {
			loading,
			goback,
			communityRightContent,
			detailTitle,
		},
		data() {
			return {
				isShowTitle: false,

				htmlData: '',
				// 内容详情
				afterhtmlData: '',

				detailInfo: {}
			}
		},
		computed: {
			isLogin() {
				return this.$store.state.isLogin
			},
			userInfo() {
				return this.$store.state.userInfo
			},
            isAnswer() {
				// 是否为问答详情页
				const query = this.$route.query
				return query.type === 'answer' || !query.type
			}
		},
		watch: {
			$route: {
				handler(val) {
					this.initQuestionDesc()
					this.$refs.rightChild.initRightContent()
				},
				deep: true
			},
		},
		async mounted() {
			await this.initQuestionDesc()
			// 监听滚动事件
			window.addEventListener('scroll', this.handlerScroll)
			// 处理单条评论展开后，"收起"吸底效果
			window.addEventListener('resize', this.handlerResize)
		},
		destroyed() {
			window.removeEventListener('scroll', this.handlerScroll)
			window.removeEventListener('resize', this.handlerResize)
			localStorage.removeItem('page')
		},
		methods: {
			getImgUrl (event) {
				if (event.target.tagName.toUpperCase() === 'IMG') {
					let href = event.target.currentSrc
					if (href.indexOf('file') !== -1) {
						href = href.replace('file', 'cos-website.ap-shanghai')
					}
					if (/\.(png|jpg|gif|jpeg|bmp|webp)(\/)?$/i.test(href)) {
						window.open(href, '_blank')
					}
				}
			},
			// 去登录
			onLogin () {
				axios.get(myUrl + 'login/test/')
			},
			// 获取到提问描述
			async initQuestionDesc () {
				try {
                    const draftInfo = localStorage.getItem('draftInfo')
                    this.detailInfo = JSON.parse(draftInfo) || {}
					// 判断拿到的text文字是不是Markdown，是的话前端需要进行转化
					if (this.detailInfo.format !== 'Markdown') {
						this.afterhtmlData = filterXSS(this.detailInfo.description)
					} else {
						this.htmlData = this.detailInfo.description
						this.$nextTick(() => {
							const data = mavonEditor.markdownIt.render(this.htmlData)
							const resData = tools.setImgCustomAttr(data)
							this.afterhtmlData = filterXSS(resData)
						})
					}
				} catch (error) {
					console.warn(error)
				}
			},
			// 监听页面滚动
			handlerScroll () {
				// 导航栏是否展示用户信息和title
				let documentScroll = $(document).scrollTop()
				this.isShowTitle = documentScroll >= 20
				const fixedTitleDom = document.querySelector('.fixed-title')
				if (fixedTitleDom && !fixedTitleDom.style.left) {
					const centerContent = document.querySelector('.center-content')
					const centerLeft = centerContent && centerContent.getBoundingClientRect().left
					const left = centerLeft > 220 ? centerLeft : 220
					fixedTitleDom.style.left = left - 59 + 'px'
					fixedTitleDom.style.top = '10px'
				}

				// 返回顶部距离相关回答40px设置
				const goBackDom = document.querySelector('.go-back')
				if (goBackDom) {
					const centerContent = document.querySelector('.center-content')
					const centerLeft = centerContent && centerContent.getBoundingClientRect().left
					// 相关回答的left + 宽度 + 40
					goBackDom.style.left = centerLeft + 830 + 12 + 356 + 40 + 'px'
				}
			},
			// 跳转到个人中心
			toPersonal () {
				let routeData = this.$router.resolve({
					path: `/s-mart/personal_center/`
				})

				window.open(routeData.href, '_blank')
			},
			// 监听页面尺寸变化
			handlerResize () {
				// 计算操作区域的left和相关问答left
				const centerContent = document.querySelector('.center-content')
				const centerLeft = centerContent && centerContent.getBoundingClientRect().left

				// 标题用户详情left设置
				const fixedTitleDom = document.querySelector('.fixed-title')
				if (fixedTitleDom) {
					const left = centerLeft > 220 ? centerLeft : 220
					fixedTitleDom.style.left = left - 59 + 'px'
				}

				// 返回顶部距离相关回答40px设置
				const goBackDom = document.querySelector('.go-back')
				if (goBackDom) {
					// 相关回答的left + 宽度 + 40
					goBackDom.style.left = centerLeft + 830 + 12 + 356 + 40 + 'px'
				}
			}
		}
	}
</script>

<style lang="scss">
	.bk-dialog {
		z-index: 100002 !important;
	}
	.icon-tip {
		z-index: 100000 !important;
	}
</style>
<style lang="scss" scoped type="text/scss">
	.question-wrapper {
		position: relative;
		background: #f5f7fa;
		padding-top: 60px;
	}

	.content-wrapper {
		width: 1257px;
		margin: 0 auto;
		padding: 72px 0 30px;
		display: flex;
		align-items: start;
		.center-content {
			width: 830px;
			margin-left: 59px;
			.center-top-content {
				margin-bottom: 10px;
				width: 830px;
				padding-top: 20px;
				background-color: #ffffff;
				box-shadow: 0px 2px 4px 0px rgba(9, 11, 26, 0.1);
				.basic-info {
					padding: 0 20px;
					font-size: 12px;
					.tags {
						padding-bottom: 12px;
						border-bottom: 1px solid #f4f4f4;
						display: flex;
						flex-wrap: wrap;
						align-items: center;
						> li {
							flex-shrink: 0;
							padding: 0 12px;
							margin: 0 10px 10px 0;
							line-height: 19px;
							color: #888991;
							background: #fafafc;
							border-radius: 11px;
							border: 1px solid #e3e8f2;
						}
					}
					.questioner-info {
						margin: 10px 0;
						display: flex;
						align-items: center;
						position: relative;
						line-height: 16px;

						span {
							color: #63656e;
							&.user-portrait {
								img {
									cursor: pointer;
									border-radius: 50%;
								}
							}
							&.questioner-name {
								margin: 0 5px 0 7px;
								color: #828282;
							}
						}
						.editor-list {
							position: absolute;
							top: 5px;
							right: 0;
							display: flex;
							align-items: center;
							li {
								color: #63656e;
								margin-left: 10px;
								cursor: pointer;
								&:hover {
									color: #3a84ff;
								}
							}
						}
					}
				}
				.question-content {
					padding: 0 20px;
					.question-desc {
						padding: 20px 0;
						font-size: 14px;
						line-height: 24px;
						color: #4f515e;
						border-bottom: none !important;
						p {
							img {
							width: 100%;
							cursor: pointer;
							}
						}
					}
				}
			}
		}
		.right-content {
			margin-left: 12px;
			width: 356px;
			box-shadow: 0px 2px 4px 0px rgba(9, 11, 26, 0.1);
			.similar-answers {
				width: 356px;
				background-color: #ffffff;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// preview.vue?d40a467e